import { render, staticRenderFns } from "./PricesCardDaLeo.vue?vue&type=template&id=4b69fa6c&"
import script from "./PricesCardDaLeo.vue?vue&type=script&lang=js&"
export * from "./PricesCardDaLeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports